angular.module("articles_adapter_module").directive("articlesAdapterSetup", [
    function () {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: '/static/assets/khapps/article_adapter_module/partials/article_adapter_setup.html'
        }
    }]);
